<template>
    <BaseSection class="flexible-sections-link-block">
        <template
            v-if="title"
            #title
        >
            <h2 class="flexible-sections-link-block__title">{{ title }}</h2>
        </template>

        <template
            v-if="description"
            #description
        >
            {{ description }}
        </template>

        <template
            v-if="externalLink || internalLink?.[0]?.uri"
            #default
        >
            <NuxtLink
                v-if="internalLink.length !== 0"
                class="flexible-sections-link-block__link"
                :to="'/'+internalLink?.[0]?.uri"
            >
                {{ t('visit-page') }}

                <BaseIcon icon="arrow-right" />
            </NuxtLink>

            <a
                v-else-if="externalLink"
                class="flexible-sections-link-block__link"
                :href="externalLink"
                target="_blank"
            >
                {{ t('visit-site') }}
                <BaseIcon icon="arrow-right" />
            </a>
        </template>
    </BaseSection>
</template>

<script setup>
defineProps({
    title: {
        type: String,
        default: null,
        required: false
    },
    description: {
        type: String,
        default: null,
        required: false
    },
    externalLink: {
        type: String,
        default: null,
        required: false
    },
    internalLink: {
        type: Array,
        default: () => [],
        required: false
    }
});

const t = useTranslation('components');
</script>

<style lang="less">
.flexible-sections-link-block {
    --spacing-section: 1rem;
    background: var(--color-primary-200);
    padding: 1rem;
    line-height: var(--lineHeight-md);
    font-size: var(--font-size-md);

    .section__header,
    .section__wrapper {
        --row-gap: .5rem;
        display: flex;
        flex-direction: column;
        gap: var(--row-gap);
    }
}

.flexible-sections-link-block__title {
    .typography-h4();
    color: var(--color-primary-700);
    line-height: var(--lineHeight-xs);
}

.flexible-sections-link-block__link {
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: .25rem;
    color: currentColor;

    .dn-icon {
        font-size: 1.5rem;
        transition: transform .2s ease-in-out;
    }

    &:hover .dn-icon {
        transform: translateX(.25rem);
    }
}
</style>
